import { createSelector } from 'reselect'
import userTypes from '../../../helpers/enums/userTypes'
import { IStore } from '../../reducers/index'

const userTypeSelector = (state: IStore) => state.app.isTeacher

export default createSelector(userTypeSelector, (userType) =>
	userType === true ? userTypes.TEACHER : userTypes.STUDENT
)
